<template>
  <div>
    <!-- 當開啟header清單不顯示 -->
    <section class="top-widget weather" 
    v-show="!Onboarding_action"
    >
      <div class="weather-data">
        <div class="current-icon">
          <img :src="'../../../../static/weather/'+weather.icon+'.svg'" :alt="weather.city">
        </div>
        <div class="current-temp">
          <p class="degree">{{weather.lowDegree}}~{{weather.maxDegree}}<sup>&#8451;</sup></p>
          <p class="rain-percent">{{weather.pop}}%</p>
        </div>
      </div>
      <div class="weather-state">
        <h3>{{weather.city}}</h3>
        <p>{{weather.wx}}</p>
      </div>
      <div class="close">
        <a @click.prevent="closeWidget()">close</a>
      </div>
    </section>
  </div>
</template>
<script>
import iconData from './weatherIconData.js'
import { EventBus } from '../../../bus.js'
import { mapGetters } from 'vuex'

// let key = {
//   'x-api-key': process.env.WEATHER_API_KEY
// }

export default {
  computed: {
    ...mapGetters([
      'appLoc',
      'app_conversation_id'
    ])
  },
  props: {
    Onboarding_action: {
      type: Boolean,
      required: false
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isWeather: false,
      weather: {
        pop: 40,
        lowDegree: 23,
        maxDegree: 32,
        city: '新北市',
        wx: '',
        icon: ''
      },
      userLocation: {
        lat: undefined,
        lon: undefined
      },
      appGPSLocation: {},
      appGpsLater:{}
    };
  },
  methods: {
    // 取得天氣資訊（取得使用者定位後再開始抓資料）
    async getWeatherData(headers) {
      await this.getUserLocation()
      console.log('weather post')
      
      await this.axios
        .post(process.env.WEATHER_API,this.userLocation)
        .then(response => {
          if(response.status === 200){
            const weatherData = response.data.data
            this.weather.pop = weatherData.pop
            this.weather.city = weatherData.city
            this.weather.lowDegree = weatherData.min_t
            this.weather.maxDegree = weatherData.max_t
            this.weather.wx = weatherData.wx
            if(this.weather.wx !== undefined){
              this.getWeatherIcon()
            }
            this.checkOpen()
          }
      })      
    },
    // 取得使用者定位
    async getUserLocation() {
      if (localStorage.getItem('GPSLocationData') !== null && localStorage.getItem('GPSLocationData') != '') {
        console.log('app');
        console.log(`appLoc:${this.appLoc}`);
        const position = localStorage.getItem('GPSLocationData')
        this.positionToNum(position)
      }
      // 使用瀏覽器定位開啟以下註解
      else {
        console.log('desk');
        // const position = await this.getCoordinates()
        // this.userLocation.lat = position.coords.latitude
        // this.userLocation.lon = position.coords.longitude
      }
    },
    // app定位資訊轉成數字
    positionToNum(gpsStr) {
      const gpsList = gpsStr.split(/\s*(,|$)\s*/)
      this.userLocation.lat = parseFloat(gpsList[0])
      this.userLocation.lon = parseFloat(gpsList[2])
    },
    // 用天氣狀況找出對應的SVG
    getWeatherIcon(){
      let iconIndex = iconData.findIndex(val => val.wx===this.weather.wx);
      this.weather.icon = iconData[iconIndex].svgNum
    },
    // 判斷是否曾點選移除天氣區塊，若沒有才顯示
    checkOpen(){
      if(sessionStorage.getItem("conversation_id") !== ''&& localStorage.getItem("close_widget")){
        this.isWeather = false
      }else {
        this.isWeather = true
      }
    },
    // 移除天氣區塊並紀錄在Storage
    closeWidget() {
      this.isWeather = false
      localStorage.setItem("close_widget", "true")
    },
    // 開啟天氣區塊
    openWidget() {
      if(this.weather.wx !== ''){
        this.isWeather = true
      }
    },
    // 開啟瀏覽器定位，目前不會用到
    // getCoordinates() {
    //   return new Promise(function(resolve, reject) {
    //     navigator.geolocation.getCurrentPosition(resolve, reject);
    //   });
    // },
  },
  watch: {
    // 監聽天氣區塊顯示判斷
    isWeather: function(value) {
      this.$emit('isWeather', this.isWeather)
    },
    appLoc: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getWeatherData()
        }
      },
      immediate: true
    }
  },
  mounted () {
    // 當是udn news才抓取資料天氣
    setTimeout(
      () => {
        this.appGpsLater = localStorage.getItem('GPSLocationData') 
        console.log(`setTimeout:${localStorage.getItem('GPSLocationData')}`);
        this.$nextTick(function () {
          this.getWeatherData()
        })
      }
    , 100)
  },
  created () {
    EventBus.$on('openWeather',()=>{
      this.openWidget()
    })
  },
  beforeDestroy () {
    EventBus.$off('openWeather')
  }
}
</script>

<style scoped>
.top-widget {
  position: fixed;
  top: 108px;
  left: 50%;
  z-index: 3;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: calc(100% - 72px);
  border-radius: 5px;
  background: #fff;
  color: #263238;
  -webkit-box-shadow: 0px 3px 31px 0px rgba(14,1,61,0.07);
  box-shadow: 0px 3px 31px 0px rgba(14,1,61,0.07);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 8px 16px;
}
.top-widget.weather {
  display: flex;
}
.weather-data {
  padding-right: 10px;
  padding-left: 50px;
  position: relative;
}
.weather-data:before {
  content: "";
  display: block;
  height: 100%;
  width: 0.5px;
  background: #e5e9f1;
  position: absolute;
  right: 0;
  top: 0;
}
.current-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
}
.current-icon img {width: 100%;}
.current-temp .degree {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 6px;
}
.current-temp .degree sup {
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, .6);
  vertical-align: super;
}
.rain-percent {
  position: relative;
  padding-left: 16px;
  color: #ACADB0;
  font-size: 12px;
}
.rain-percent:before {
  display: block;
  content: "";
  width: 13px;
  height: 13px;
  background: url(../assets/weather/icon-umbrella.png) no-repeat center/contain;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.weather-state {
  padding-left: 10px; 
  display: flex; 
  flex-direction: column;
  justify-content: center;
}
.weather-state h3 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
}
.weather-state p {
  align-self: flex-end;
  font-size: 12px;
  color: #ACADB0;
}
.top-widget .close {
  display: block;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 48px;
}
.top-widget .close a {
  display: block;
  width: inherit;
  height: inherit;
  text-indent: -9999px;
  background: url(../assets/icon_close_s.png) no-repeat center/8px 8px;
  cursor: pointer;
}

@media only screen and (max-device-width: 480px){
  .top-widget {
    top: 90px;
    width: calc(100% - 48px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Weather/Weather.vue